// project-imports
import { getDateTimeFields, getFormattedDate, getLocalDateTimeFields, handleDateFormat } from 'helpers/dates';
import { isEmptyObject } from 'helpers/objectFunctions';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'store';
import { gridSpacing, rowsPerPagePaginationAlt } from 'store/constant';
import { filterData, getAdditionalFilterData, getIndividualMembersTicketsData } from 'store/slices/memberPriority';
import MainCard from 'ui-component/cards/MainCard';
import SubCard from 'ui-component/cards/SubCard';
import { CHANNEL_REQUESTS, DEFAULT_ORDER, DEFAULT_ORDER_BY, STATUS_REQUESTS, ticketsHeadCells } from '../constant';
import useStyles from '../styles';

// material-ui
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import useTheme from '@mui/material/styles/useTheme';
import EnhancedTableHead from 'views/forms/tables/TableEnhanced';
import { capitalizeString } from 'helpers/stringFunctions';
import getPriorityChipByType from 'views/pages/internal-commenting/commons';
import { devConsolelog } from 'helpers/utilityFunctions';
import { Button, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import DialogModal from 'views/ui-elements/commons/dialogModal';
import InternalQueryPopup from 'views/pages/internal-commenting/internalQueryPopup';
import { getChatMessage } from 'store/slices/chat';
import { clearData } from 'store/slices/internalCommenting';

const TableHeading = () => (
    <>
        {ticketsHeadCells.map((item) => (
            <TableCell align={item.align} sx={{ pl: 4, minWidth: '150px' }}>
                {item?.label}
            </TableCell>
        ))}
    </>
);

const Tickets = () => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const classes = useStyles();

    const memberPriorityData = useSelector((state) => state?.memberPriority);
    const [order, setOrder] = useState(DEFAULT_ORDER);
    const [orderBy, setOrderBy] = useState(DEFAULT_ORDER_BY);
    const [statusFilter, setStatusFilter] = useState({ id: 'all', name: 'All' });
    const [channelFilter, setChannelFilter] = useState({ id: 1, name: 'Travclan Help' });
    const [openModal, setOpenModal] = useState(false);
    const { selectedMember = {}, filters: appliedFilters = {}, isDataLoading = false, ticketData = {} } = memberPriorityData || {};
    devConsolelog('member12daa', memberPriorityData);
    const { code: memberCode = '' } = selectedMember || {};
    const {
        membersTicketsList = [],
        count = 0,
        next = null,
        previous = null,
        page_size: rowsPerPage = rowsPerPagePaginationAlt,
        currentPage = 0,
        utilities = {}
    } = ticketData || {};

    const memberCodeTemp = 'mjtt4';

    const { oc_tickets_count: ocTicketCount = {} } = utilities || {};
    const { total = '', open = '', close = '' } = ocTicketCount || {};

    const handleChangePage = (event, nextPage) => {
        devConsolelog('next1343', next);
        if (nextPage - currentPage > 0) {
            // next
            dispatch(getIndividualMembersTicketsData(next, '', memberCode, nextPage));
        } else if (nextPage - currentPage < 0) {
            // previous
            dispatch(getIndividualMembersTicketsData(previous, '', memberCode, nextPage));
        }
    };

    const handleRequestSort = useCallback(
        async (event, newOrderBy) => {
            const isAsc = orderBy === newOrderBy && order === 'asc';
            const toggledOrder = isAsc ? 'desc' : 'asc';
            setOrder(toggledOrder);
            setOrderBy(newOrderBy);

            const id = toggledOrder === 'desc' ? `-${newOrderBy}` : newOrderBy;

            const tempFilterTypeObj = { ordering: { id } };
            dispatch(filterData({ ...appliedFilters, ordering: tempFilterTypeObj }));
        },
        [order, orderBy, rowsPerPage, appliedFilters]
    );

    const getData = async (filterType = '') => {
        await dispatch(getIndividualMembersTicketsData('', filterType, memberCode));
    };

    const intialFilter = {
        query_type: [
            {
                id: 1,
                name: 1
            }
        ]
    };

    useEffect(() => {
        getData(intialFilter);
        getAdditionalFilterData('tags');
        getAdditionalFilterData('teams');
        return () => {
            dispatch(filterData({}));
        };
    }, []);

    useEffect(() => {
        if (!isEmptyObject(appliedFilters)) {
            devConsolelog('checking1empty1object', appliedFilters);
            getData({ ...appliedFilters });
        } else {
            getData(intialFilter);
        }
    }, [appliedFilters]);

    devConsolelog('filter231232', appliedFilters);

    const handleStatusUpdate = (e) => {
        const selectedStatus = e.target.value;
        let filtersData = {
            status: []
        };
        if (selectedStatus !== 'all') {
            filtersData = { ...filtersData, status: [{ id: selectedStatus, name: selectedStatus }] };
        }
        dispatch(filterData({ ...appliedFilters, ...filtersData }));

        // Remove status key if selectedStatus is 'all'
        if (selectedStatus === 'all' && 'status' in appliedFilters) {
            const { status, ...remainingFilters } = appliedFilters;
            devConsolelog('handleStatusUpdate', remainingFilters);
            dispatch(filterData(remainingFilters));
        } else {
            dispatch(filterData({ ...appliedFilters, ...filtersData }));
        }

        setStatusFilter({ id: selectedStatus, name: selectedStatus });
    };

    const handleChannelUpdate = (e) => {
        const selectedStatus = e.target.value;
        devConsolelog('sad3er34', selectedStatus);
        let filtersData = {};
        if (selectedStatus !== 'all') {
            filtersData = { query_type: [{ id: selectedStatus, name: selectedStatus }] };
        }
        devConsolelog('wew345', { ...appliedFilters, ...filtersData });

        // Remove query_type key if selectedStatus is 'all'
        if (selectedStatus === 'all' && 'query_type' in appliedFilters) {
            const { query_type: queryType, ...remainingFilters } = appliedFilters;
            devConsolelog('handleChannelUpdate', remainingFilters);
            dispatch(filterData(remainingFilters));
        } else {
            dispatch(filterData({ ...appliedFilters, ...filtersData }));
        }

        setChannelFilter({ id: selectedStatus, name: selectedStatus });
    };

    const handleFiltersValue = (key, filters = {}) => {
        const obj = filters[key] || {};
        return Object?.values(obj)?.[0]?.id || '';
    };

    const handleModalOpen = () => {
        setOpenModal((prevState) => !prevState);
    };

    const handleSideNavData = (code, queryType) => {
        dispatch(getChatMessage(''));
        dispatch(clearData());
        window.open(`/internal-commenting/${code}?queryType=${queryType}`, '_blank');
        // navigate(`/internal-commenting/${code}?queryType=${selectedTab}`);
    };

    return (
        <Grid container direction="column" spacing={4}>
            <Grid item display="flex" flexDirection="row" justifyContent="space-between" mt={2}>
                <Grid container spacing={3}>
                    <Grid item xs={4}>
                        <FormControl fullWidth>
                            <InputLabel id="raise-request-ticket-status">Channel</InputLabel>
                            <Select
                                id="channel"
                                name="Channel"
                                label="Channel"
                                defaultValue="all"
                                value={handleFiltersValue('channel', appliedFilters) || channelFilter?.id || ''}
                                onChange={(e) => handleChannelUpdate(e)}
                            >
                                {CHANNEL_REQUESTS.map((column) => (
                                    <MenuItem key={`index_${column.id}`} value={column.id}>
                                        {column.title}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={4}>
                        <FormControl fullWidth>
                            <InputLabel id="raise-request-ticket-status">Ticket Status</InputLabel>
                            <Select
                                id="columnId"
                                name="columnId"
                                label="Ticket Status"
                                defaultValue="all"
                                value={handleFiltersValue('status', appliedFilters) || statusFilter?.id || ''}
                                onChange={(e) => handleStatusUpdate(e)}
                            >
                                {STATUS_REQUESTS.map((column) => (
                                    <MenuItem key={`index_${column.id}`} value={column.id}>
                                        {column.title}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container justifyContent="flex-end">
                    <Button variant="text" onClick={() => handleModalOpen()}>
                        Raise New Query
                    </Button>
                </Grid>
            </Grid>

            <Grid container item spacing={2}>
                {/* <Grid item xs={12}>
                    <Typography variant="subtitle1">My Tickets</Typography>
                </Grid> */}
                <Grid item xs={12}>
                    <Grid container spacing={gridSpacing}>
                        <Grid item xs={12} sm={8} md={12} lg={12}>
                            {isDataLoading ? (
                                <Grid container sx={{ display: 'flex', justifyContent: 'center' }}>
                                    <CircularProgress />
                                </Grid>
                            ) : (
                                <SubCard
                                    sx={{
                                        ':hover': {
                                            boxShadow: 'none'
                                        }
                                    }}
                                    content={false}
                                >
                                    <Grid item xs={12}>
                                        {/* table */}
                                        <TableContainer>
                                            <Table aria-label="simple table" sx={{ minWidth: '100%', width: '110rem' }} stickyHeader>
                                                <EnhancedTableHead
                                                    headCells={ticketsHeadCells}
                                                    order={order}
                                                    orderBy={orderBy}
                                                    onRequestSort={handleRequestSort}
                                                    tableCellClass={classes.queryTable}
                                                />
                                                <TableBody>
                                                    {membersTicketsList.map((ticket) => {
                                                        const {
                                                            code: ticketCode = '',
                                                            category = {},
                                                            request_type: requestType = {},
                                                            status = '',
                                                            updated_at: updatedAt = '',
                                                            request_type_code: requestTypeCode = '',
                                                            assigned_to: assignedTo = {},
                                                            conversation = {},
                                                            created_by: ticketCreatedBy = {},
                                                            next_action_at: nextActionAt = '',
                                                            tags = [],
                                                            team = {},
                                                            query_type: queryType = '',
                                                            priority_type: priorityType = ''
                                                        } = ticket || {};

                                                        devConsolelog('ticket1each', ticket);

                                                        const { username: ticketUsername = '' } = ticketCreatedBy || {};

                                                        const { name: categoryName = '' } = category || {};
                                                        const { name: requestName = '' } = requestType || {};
                                                        const { username = '' } = assignedTo || {};
                                                        const { created_by: createdBy = '', given_by: givenBy = '' } = conversation || {};
                                                        const { name: teamName = '' } = team || {};

                                                        const { hours24: hrsLastActUpdatedAt = '', minutes: minLastActUpdatedAt = '' } =
                                                            getLocalDateTimeFields(updatedAt) || {};

                                                        return (
                                                            <TableRow
                                                                hover
                                                                key={ticketCode}
                                                                sx={{ cursor: 'pointer' }}
                                                                onClick={() => handleSideNavData(ticketCode, queryType)}
                                                            >
                                                                <TableCell
                                                                    sx={{
                                                                        minWidth: '100px',
                                                                        fontWeight: 500,
                                                                        cursor: 'pointer',
                                                                        color: theme.palette.primary.dark
                                                                    }}
                                                                >
                                                                    {ticketCode}
                                                                </TableCell>
                                                                <TableCell sx={{ minWidth: '100px' }}>
                                                                    <Typography
                                                                        variant="div"
                                                                        sx={{
                                                                            color: status === 'all' ? 'warning.dark' : 'inherit'
                                                                        }}
                                                                    >
                                                                        {capitalizeString(status, ' ')}
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell sx={{ minWidth: '100px' }}>{requestTypeCode}</TableCell>
                                                                <TableCell sx={{ minWidth: '100px' }}>{categoryName || '-'}</TableCell>
                                                                <TableCell sx={{ minWidth: '130px' }}>{requestName || '-'}</TableCell>
                                                                <TableCell sx={{ minWidth: '130px' }}>
                                                                    {tags?.length > 0
                                                                        ? tags.map((item, index) => (
                                                                              <Typography>
                                                                                  {item?.name}
                                                                                  {index !== tags?.length - 1 ? ',' : ''}
                                                                              </Typography>
                                                                          ))
                                                                        : '-'}
                                                                </TableCell>
                                                                <TableCell sx={{ minWidth: '130px' }}>{teamName || '-'}</TableCell>
                                                                <TableCell sx={{ minWidth: '130px' }}>{username || '-'}</TableCell>
                                                                <TableCell sx={{ minWidth: '130px' }}>
                                                                    {getPriorityChipByType(priorityType)}
                                                                </TableCell>

                                                                <TableCell sx={{ minWidth: '130px' }}>{ticketUsername || '-'}</TableCell>
                                                                <TableCell sx={{ minWidth: '120px' }}>
                                                                    {nextActionAt ? handleDateFormat(nextActionAt, true) : '-'}
                                                                </TableCell>
                                                                <TableCell sx={{ minWidth: '120px' }}>{createdBy || '-'}</TableCell>
                                                                <TableCell
                                                                    sx={{
                                                                        minWidth: '120px'
                                                                    }}
                                                                    component="th"
                                                                >
                                                                    {updatedAt ? (
                                                                        <>
                                                                            <Typography>{`${getFormattedDate(
                                                                                updatedAt,
                                                                                'dd-mm-yyyy',
                                                                                true
                                                                            )}`}</Typography>
                                                                            <Typography
                                                                                variant="h6"
                                                                                sx={{
                                                                                    color: theme.palette.grey[500],
                                                                                    fontWeight: 400
                                                                                }}
                                                                            >
                                                                                {`${hrsLastActUpdatedAt}:${minLastActUpdatedAt}`}
                                                                            </Typography>
                                                                        </>
                                                                    ) : (
                                                                        '-'
                                                                    )}
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                        <TablePagination
                                            rowsPerPageOptions={[rowsPerPage]}
                                            component="div"
                                            rowsPerPage={rowsPerPage}
                                            page={currentPage}
                                            count={parseInt(count, 10)}
                                            backIconButtonProps={{
                                                'aria-label': 'previous page'
                                            }}
                                            nextIconButtonProps={{
                                                'aria-label': 'next page'
                                            }}
                                            onPageChange={handleChangePage}
                                            labelDisplayedRows={({ count }) =>
                                                `Page ${currentPage + 1} of ${Math.ceil(parseInt(count, 10) / rowsPerPage)}`
                                            }
                                            sx={{ '& .MuiTablePagination-toolbar': { padding: 0 } }}
                                        />
                                    </Grid>
                                </SubCard>
                            )}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <DialogModal
                open={openModal}
                bodyText={<InternalQueryPopup isRaiseNewQuery handleModalOpen={handleModalOpen} selectedTab={1} />}
                titleText="Raise New Query"
                showDivider
                onClose={() => handleModalOpen()}
            />
        </Grid>
    );
};

export default Tickets;
